module.exports = new __parcel__URL__("step_five_vector_dark_optimal.d2b5a6c3.png").toString();